import ImageCroppingContainer from "./ImageCroppingContainer";
export default function InsertionImagePreview({
  focusedImageId,
  itemToView,
  atnIdList,
  onEvent,
  toolbar,
  nextButton,


}){


  let imagePreview;
  if( !focusedImageId && !itemToView ){
    imagePreview = (
      <div style={{
        paddingTop:'30%',
      }} class="flex-expand sg-row rel">
        <h2 class="full-width" style={{textAlign:'center'}}>
          Select an image to continue.
        </h2>
      </div>
    )
  }else{



    imagePreview = (
      <ImageCroppingContainer 
        key={itemToView ? Math.random() : focusedImageId}
        {...{
          nextButton,
        atnIdList,
        onEvent,
        toolbar,
        showFilesystem:false,
        selectedImageId:(
          focusedImageId//?.includes("MERGE")?virtImageId:focusedImageId
        ),
        //virtImageId,
        showSidebar:false,
        mode:"regionChoice",
        imageToRender:itemToView
      }}/>
    )
  }
  return imagePreview;

}
